import { motion } from "framer-motion";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";
import { HOW_PRICING_WORKS } from "../lib/plans";

const HowPricingWorks = () => (
    <section
        data-testid="how-pricing-works-section"
        className="relative border-y border-white/10 bg-surface/50 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    HOW PRICING WORKS
                </p>
                <span className="h-px flex-1 bg-white/10" />
            </motion.div>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-12 grid gap-10 md:grid-cols-3"
            >
                {HOW_PRICING_WORKS.map((block) => (
                    <motion.div
                        key={block.code}
                        variants={fadeUp}
                        data-testid={`pricing-how-${block.code.toLowerCase().replace(".", "-")}`}
                        className="border-t border-white/15 pt-6"
                    >
                        <p className="font-mono text-[13px] tracking-[0.3em] text-accent">
                            {block.code}
                        </p>
                        <h3 className="mt-4 font-display text-xl font-semibold leading-snug text-white">
                            {block.title}
                        </h3>
                        <p className="mt-3 text-[15px] leading-relaxed text-mist">
                            {block.copy}
                        </p>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    </section>
);

export default HowPricingWorks;
